import VueI18n from 'vue-i18n'

export default class PageTitleManager {
  document: Document

  i18n: VueI18n

  constructor(document: Document, i18n: VueI18n) {
    this.document = document
    this.i18n = i18n
  }

  update(currentPage: string): void {
    const pageTitleKey = `pages.${currentPage}.title`
    const suffix = this.i18n.t('common.pageTitleSuffix') as string

    if (this.i18n.te(pageTitleKey)) {
      this.document.title = `${this.i18n.t(pageTitleKey)} - ${suffix}`
    } else {
      this.document.title = suffix
    }
  }
}
